import { render } from "./InfoModal.vue?vue&type=template&id=f42029b6&scoped=true&ts=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=f42029b6&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42029b6"]])

export default __exports__